module.exports = __webpack_public_path__ + "img/banner3.650160f8.jpg";